import { gql } from 'apollo-angular';

export const AIStrategyGeneratePDFDocument = gql`
  query aiStrategyGeneratePDF($funnelId: Int!, $logo: String!) {
    aiStrategyGeneratePDF(funnelId: $funnelId, logo: $logo)
  }
`;
